import { clsx } from 'clsx';
import { paths } from '@/routes-utils/paths.ts';
import { footerContainer, footerLink, linksContainer } from './footer.css.ts';

export const Footer = ({ className }: { className?: string }) => {
  const currentYear = new Date().getFullYear();

  return (
    <div className={clsx(footerContainer, className)}>
      <div>Synoptic © {currentYear}</div>
      <div className={linksContainer}>
        <a
          href={`mailto:info@synoptic.com`}
          target={'_blank'}
          className={footerLink}
          rel="noreferrer"
        >
          Contact us
        </a>
        <a
          href={'https://x.com/SynopticCom'}
          target={'_blank'}
          className={footerLink}
          rel="noreferrer"
        >
          Twitter
        </a>
        <a
          href={paths.termsOfUse}
          target={'_blank'}
          className={footerLink}
          rel="noreferrer"
        >
          Terms of Service
        </a>
        <a
          href={paths.privacyPolicy}
          target={'_blank'}
          className={footerLink}
          rel="noreferrer"
        >
          Privacy Policy
        </a>
      </div>
    </div>
  );
};
